const DOUBLE_SLASHES = /\/\//g;

export function join(...paths) {
  return paths.join('').replace(DOUBLE_SLASHES, '/');
}
